import {Menu} from "@mantine/core";
import IconTrash from "../../../../assets/trash.svg?react";
import IconShare from "../../../../assets/share-2.svg?react";
import IconPencil from "../../../../assets/pencil.svg?react";
import {useNavigate, useParams} from "react-router-dom";
import {chatApi} from "../../chatApi";
import {useTranslation} from "react-i18next";

interface Props {
    id: string;
    children: React.ReactNode;
    onOpen: () => void;
    onClose: () => void;
}

const ThreadButtonMenu: React.FC<Props> = ({id, children, onOpen, onClose}) => {
    const {t} = useTranslation();
    const {threadId} = useParams();
    const [deleteThread] = chatApi.endpoints.deleteThread.useMutation();
    const navigate = useNavigate();

    const handleDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        deleteThread(id);
        onClose();

        if (threadId === id) {
            navigate("/");
        }
    };

    return (
        <Menu
            position="bottom-start"
            onOpen={onOpen}
            onClose={onClose}
            closeOnClickOutside
            closeOnEscape
        >
            <Menu.Target>{children}</Menu.Target>
            <Menu.Dropdown>
                {/*                 <Menu.Item leftSection={<IconShare width={16} />}>
                    {t("common.share")}
                </Menu.Item>
                <Menu.Item leftSection={<IconPencil width={16} />}>
                    {t("common.rename")}
                </Menu.Item> */}
                <Menu.Item
                    leftSection={<IconTrash width={16} />}
                    onClick={handleDelete}
                >
                    {t("common.delete")}
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};

export default ThreadButtonMenu;
